import { createActions } from 'redux-actions';

import types from './actionTypes';

const { ui } = createActions({
  [types.SET_LOADING]: ({ loading }) => ({ loading }),
});

export default ui;